import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/logo.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-892eddc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header__content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "header__logo-desktop",
    alt: "logo-decktop",
    src: _imports_0
  })
], -1))
const _hoisted_4 = { class: "header__btn-group" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Авторизация", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Регистрация", -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_iconProfile = _resolveComponent("iconProfile")!
  const _component_iconAddUser = _resolveComponent("iconAddUser")!
  const _component_LoginModal = _resolveComponent("LoginModal")!
  const _component_RegistrationModal = _resolveComponent("RegistrationModal")!
  const _component_ResetPasswordModal = _resolveComponent("ResetPasswordModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          (!_ctx.isAuth)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-primary header__btn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showLoginModal()))
              }, _hoisted_6))
            : _createCommentVNode("", true),
          (!_ctx.isAuth)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "header__icon-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showLoginModal()))
              }, [
                _createVNode(_component_iconProfile, { class: "header__icon" })
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isAuth)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "btn btn-primary header__btn",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showRegistrationModal()))
              }, _hoisted_8))
            : _createCommentVNode("", true),
          (!_ctx.isAuth)
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                class: "header__icon-btn",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showRegistrationModal()))
              }, [
                _createVNode(_component_iconAddUser, { class: "header__icon" })
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_LoginModal, {
      ref: "loginModalRef",
      onOpenRegistration: _ctx.showRegistrationModal,
      onResetPass: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showResetPassModal()))
    }, null, 8, ["onOpenRegistration"]),
    _createVNode(_component_RegistrationModal, {
      ref: "registrationModalRef",
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showRegistrationModal())),
      onOpenAuthModal: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showLoginModal()))
    }, null, 512),
    _createVNode(_component_ResetPasswordModal, {
      ref: "resetPasswordRef",
      onOpenAuthModal: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showLoginModal())),
      onOpenRegModal: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showRegistrationModal()))
    }, null, 512)
  ], 64))
}